import Vue from "vue"
// 定义一个vue对象，起名叫bus。
var bus=new Vue();

// 导出
export default bus;